import { render, staticRenderFns } from "./handle-cer-qualified.vue?vue&type=template&id=c1646434&"
import script from "./handle-cer-qualified.vue?vue&type=script&lang=js&"
export * from "./handle-cer-qualified.vue?vue&type=script&lang=js&"
import style0 from "./handle-cer-qualified.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports